import createMuiTheme, { ThemeOptions } from '@material-ui/core/styles/createMuiTheme';

import { base, Theme } from './base';

export const dark = createMuiTheme({
  ...base,
  name: 'dark',
  palette: {
    ...base.palette,
    primary: {
      light: '#064267',
      main: '#0C2E3D',
      dark: '#333333',
    },
  },
} as ThemeOptions) as Theme;
